module.exports = __webpack_public_path__ + "img/11.429f7407.png";